import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message, Upload } from 'antd';
import axiosInstance from '../../utils/axios';


const StateModal = ({ open, setOpen, states, setStates, selectedId, countries}) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		if (open) {
			if (selectedId !== null) {
				const item = states.find(p => p.id === selectedId);
				setSelectedItem(item);

				if (item) {
					form.setFieldsValue({ name: item.name });
				}

			} else {
				setSelectedItem(null);
				form.resetFields();
			}
		}
	}, [open, selectedId, states]);

	const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setSelectedItem(null);
  };

	const handleFinish = async (values) => {
    setLoading(true);

    try {
      let response;
      if (selectedItem) {
        response = await axiosInstance.patch(`core/state/${selectedItem.id}/`, values);
        setStates(prev => prev.map(p => (p.id === selectedItem.id ? response.data : p)));
        message.success("State updated successfully!");

      } else {
        response = await axiosInstance.post(`core/state/`, {
            name: values.name,
            country: countries[0].id
        });
        setStates(prev => [...prev, response.data]);
        message.success("State added successfully!");
      }

      form.resetFields();
      setOpen(false);
    } catch (error) {
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

	return (
		<Modal
			title={selectedItem ? "Edit State" : "Add new State"}
            open={open}
            onCancel={handleCancel}
            destroyOnClose
            okButtonProps={{
                autoFocus: true,
                htmlType: 'submit',
                loading: loading,
                disabled: loading,
            }}
            onOk={() => form.submit()}
		>
 			<Form
                layout="vertical"
                form={form}
                name="language_form"
                onFinish={handleFinish}
            >
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: 'Please enter a german state' }]}
                >
                    <Input />
                </Form.Item>
            </Form>
		</Modal>
	)
}

export default StateModal